import { Controller } from "@hotwired/stimulus"

// Swaps the brand tile for the chosen file before upload, so an operator can see the
// mark they picked without a round trip. Falls back silently when no file is chosen.
export default class extends Controller {
  static targets = ["input", "preview", "placeholder", "clear"]

  show() {
    const file = this.inputTarget.files && this.inputTarget.files[0]
    if (!file) return

    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = URL.createObjectURL(file)
    this.previewTarget.src = this.objectUrl
    this.previewTarget.classList.remove("hidden")
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden")
    if (this.hasClearTarget) this.clearTarget.checked = false
  }

  disconnect() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
  }
}
